<script setup lang="ts">
  const isOpen = defineModel<boolean>()
  withDefaults(
    defineProps<{
      isValid: boolean
    }>(),
    { isValid: false }
  )
</script>
<template>
  <DialogRoot v-model:open="isOpen">
    <DialogPortal>
      <DialogOverlay class="fixed inset-0 z-50 bg-black/75" />
      <DialogContent
        class="fixed left-1/2 top-20 z-50 h-104 w-11/12 -translate-x-1/2 translate-y-20 rounded-sm bg-white p-4 md:top-1/3 md:h-130 md:w-138 md:-translate-y-1/3 md:p-6"
      >
        <div class="flex w-full justify-end">
          <DialogClose
            class="absolute"
            :aria-label="$t('aria.label.close')"
          >
            <Icon
              class="text-bt-blue-dark"
              name="common/close"
            />
          </DialogClose>
        </div>
        <div class="flex h-full flex-col items-center justify-center">
          <div class="relative mb-4 flex size-20 items-center justify-center md:mb-10">
            <span
              class="absolute inline-flex size-3/4 animate-ping rounded-full opacity-75"
              :class="isValid ? 'bg-dark-success' : 'bg-dark-error'"
            />
            <span
              class="relative flex size-20 items-center justify-center rounded-full text-white"
              :class="isValid ? 'bg-dark-success' : 'bg-dark-error'"
            >
              <Icon
                size="lg"
                :name="isValid ? 'common/round-check' : 'common/close'"
              />
            </span>
          </div>
          <DialogTitle
            as="h4"
            class="mb-2 md:mb-4"
          >
            <slot name="title" />
          </DialogTitle>
          <DialogDescription class="mb-0 text-center text-body-1">
            <slot name="description" />
          </DialogDescription>
          <DialogClose as-child>
            <slot name="button" />
          </DialogClose>
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
